export default __webpack_public_path__ + "static/media/banner_movil_pef2024.55fc30ac.png";